import { render, staticRenderFns } from "./RoomTemplatesText.vue?vue&type=template&id=7a3f7ca9&scoped=true&"
import script from "./RoomTemplatesText.vue?vue&type=script&lang=js&"
export * from "./RoomTemplatesText.vue?vue&type=script&lang=js&"
import style0 from "./RoomTemplatesText.vue?vue&type=style&index=0&id=7a3f7ca9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3f7ca9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
